import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getordertracking } from "../services/Cart";
import { orderInvoice, postRatings } from "../services/Spares";
// import html2pdf from "html2pdf.js";
import "../styles/OrderDetails.css";
import noimage from "../assets/noimage.webp";
import { Card, Rate, Input, Button, Row, Col } from "antd";
import { showSnackbar } from "../comopnents/snackbar";
import LoadingSpinner from "../comopnents/LoadingSpinner";
const { TextArea } = Input;

const OrderDetails = () => {
  const { orderid } = useParams();
  const navigate = useNavigate();
  const [reviews, setReviews] = useState({});
  // const [rating, setRating] = useState(0);
  // const [review, setReview] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [hdr, setHdr] = useState({});
  const [bill, setBill] = useState({});
  const [ship, setShip] = useState({});
  const [submittedReviews, setSubmittedReviews] = useState({});

  // simple responsive check
  const isMobile = window.innerWidth <= 768;

  const handleSubmit = async (review, productid, rating) => {
    // Rating validation
    if (!rating || rating === 0) {
      showSnackbar("error", "Please provide a rating.");
      return;
    }

    // Review validation
    if (!review || review.trim() === "") {
      showSnackbar("error", "Please write a review.");
      return;
    }

    // Review length validation
    if (review.trim().length > 200) {
      showSnackbar("error", "Review cannot exceed 200 characters.");
      return;
    }

    try {
      const res = await postRatings(review.trim(), productid, rating);
      console.log(res);

      showSnackbar("success", "Rating updated successfully");
    } catch (error) {
      console.error("Rating error:", error);
      showSnackbar("error", "Failed to submit review.");
    }
  };
  const handleGetOrders = async () => {
    try {
      setLoading(true);
      const res = await getordertracking(orderid);

      const orderData = res?.data?.length > 0 ? res.data[0] : null;

      setOrder(orderData);

      if (orderData?.details) {
        const reviewedProducts = {};

        orderData.details.forEach((item) => {
          const stored = localStorage.getItem(`review_${item.productid}`);

          if (stored === "submitted") {
            reviewedProducts[item.productid] = true;
          }
        });

        setSubmittedReviews(reviewedProducts);
      }
    } catch (error) {
      console.error("Order tracking error:", error);
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

  const getOrderInvoice = async () => {
    try {
      setLoading(true);
      const res = await orderInvoice({ orderid });
      console.log("invoice", res);
      console.log("GST:", hdr?.gstamount);

      setdata(res?.data || []);
      setHdr(res?.hdr?.[0] || {});
      setBill(res?.Bill?.[0] || {});
      setShip(res?.Ship?.[0] || {});
    } catch (error) {
      console.error("Order tracking error:", error);
      setdata(null);
    } finally {
      setLoading(false);
    }
  };

  // const downloadPDF = () => {
  //   const element = document.getElementById("invoice-content");

  //   // Temporarily show hidden content
  //   element.style.display = "block";

  //   const opt = {
  //     margin: 0.3,
  //     filename: `Invoice_${hdr?.orderid || "Order"}.pdf`,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //   };

  //   html2pdf().set(opt).from(element).save().then(() => {
  //     // Hide again after PDF is generated
  //     element.style.display = "none";
  //   });
  // };
  const handlePrintLabel = () => {
    if (!data || data.length === 0) {
      alert("Invoice data not loaded yet");
      return;
    }

    const printWindow = window.open("", "_blank", "width=900,height=700");
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(
      generateInvoiceHTML(hdr, data, bill, ship, {
        igst: data.reduce((s, r) => s + (r.igstamount || 0), 0).toFixed(2),
      }),
    );
    printWindow.document.close();
  };

  const generateInvoiceHTML = (
    hdr = {},
    orderDetail = [],
    bill = {},
    ship = {},
    details = {},
  ) => {
    const header = hdr?.[0] || {};

    const paidItems = orderDetail.filter((d) => d.type === "r");

    const totalCgst = paidItems.reduce(
      (sum, d) => sum + Number(d.cgstamount || 0),
      0,
    );

    const totalSgst = paidItems.reduce(
      (sum, d) => sum + Number(d.sgstamount || 0),
      0,
    );

    const totalIgst = paidItems.reduce(
      (sum, d) => sum + Number(d.igstamount || 0),
      0,
    );
    const rows = orderDetail
      .map((item, index) => {
        if (!item?.Products || !Array.isArray(item.Products)) return "";
        return item.Products.map(
          (sub) => `
      
      <tr>
        <td>${index + 1}</td>
        <td>${sub?.hsn || 804561}</td>
        <td style="text-align:left;">
          ${sub?.modelno || "-"}
          ${sub?.mainmodelno && sub.mainmodelno !== "--" ? "," + sub.mainmodelno : ""}
        </td>
        <td>${item?.orderqty || 0}</td>
        <td>PCS</td>
        <td>${item?.type === "r" ? sub?.mrp || 0 : 0}</td>
        <td>${item?.dispercent || 0} %</td>
        <td>${item?.sdispercent || 0} %</td>
        <td>${item?.exdispercent || 0} %</td>
       <td>${(item?.totalamount / item?.orderqty || 0).toFixed(2)}</td>
        <td>${item?.igst == 0 ? item?.cgst + item?.sgst : item?.igst} %</td>
        <td>${Number(item?.totalamount || 0).toFixed(2)}</td>
      </tr>
    `,
        ).join("");
      })
      .join("");

    return `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Invoice</title>
    <style>
      body { font-family: 'Arial', sans-serif; padding: 20px; color: #000; }
  .container { 
  max-width: 950px; 
  margin: auto; 
  border: 2px solid #000;   /* ✅ 4 side outer border */
  padding: 15px;            /* ✅ space inside border */
  box-sizing: border-box; 
}

      h2, h3 { text-align: center; margin: 2px 0; font-weight: bold; }
      h2 { font-size: 18px; }
      h3 { font-size: 14px; }
      .row { display: flex; justify-content: space-between; font-size: 12px; margin: 10px 0; }
      .row div { width: 48%; padding: 8px; border: 1px solid #000; box-sizing: border-box; line-height: 1.3; }
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 10px;
}

table th,
table td {
  border: 1px solid #ccc;
  padding: 6px;
  font-size: 12px;
  line-height: 1.2;
}

table th {
  background-color: #f1f1f1;
  font-weight: bold;
  text-align: center;
}

table td {
  text-align: center;
  vertical-align: middle;   /* IMPORTANT */
}

table td:nth-child(3) {
  text-align: left;  /* Item Name left aligned */
}

/* Bottom border only for actual rows */
table tr:last-child td {
  border-bottom: 1px solid #ccc;
}
  th, td {  padding: 6px; text-align: center; vertical-align: middle; }
      th { font-weight: bold; background-color: #f1f1f1; }
      td { font-size: 12px; }
      td:nth-child(3) { text-align: left; } /* Item Name left aligned */
      .summary-grid { display: flex; margin-top: 15px; border: 1px solid #000; font-size:12px; }
      .summary-grid div { flex: 1; border-right: 1px solid #000; padding: 8px; text-align: center; }
      .summary-grid div:last-child { border-right: none; font-weight: bold; }
      .bank, .terms { border: 1px solid #000; padding: 10px; font-size: 12px; margin-top: 10px; }
      .signature { text-align: right; margin-top: 30px; font-weight: bold; }
      @media print { body { margin: 0; } .invoice-wrapper { page-break-after: always; } }
      .label {
  display: inline-block;
  width: 160px;   /* adjust spacing here */
  font-weight: bold;
}

    </style>
  </head>
  <body>
    <div class="container invoice-wrapper">
      <h3>${hdr?.orderstatus !== "Cancel" ? "TAX INVOICE" : "CANCELLED INVOICE"}</h3>
      <h2>PIXELED INDIA  PVT LTD.</h2>
      <p style="text-align:center; font-size:11px; margin:2px 0;">
      Plot No -F4,FICCI FLO, industrial Park Sultanpur,Sultanpur Village, TELANGANA, Code: 03, PIN: 502319 <br/>
    
         Mobile: 9100039893 |  PAN: AAICP0771E | GSTIN: 36AAICP0771E1ZI
      </p>

    <div class="row">
  <div>
    <span class="label">Customer Name:</span> ${ship?.name || "-"}<br/>
    <span class="label">Mobile No:</span> ${ship?.phone || "-"}<br/>
    <span class="label">PAN:</span> ${ship?.pan || "-"}<br/>
    <span class="label">GSTIN:</span> ${ship?.gstno || "-"}<br/>
    <span class="label">Address:</span> ${ship?.flathouse || ""}, ${ship?.area || ""}<br/>
    <span class="label">Land Mark:</span> ${ship?.landmark || ""}<br/>
    <span class="label">City:</span> ${ship?.city || ""}<br/>
    <span class="label">State & Pincode:</span> ${ship?.state || ""}, ${ship?.pincode || ""}
  </div>

  <div>
    <span class="label">Invoice No:</span> ${hdr?.finvvoucher || "Not Generated Yet"}<br/>
    <span class="label">Date:</span> ${hdr?.orderdate ? new Date(hdr.orderdate).toLocaleDateString() : "-"}<br/>
    <span class="label">Vehicle No:</span> ${hdr?.vehicleno || "-"}<br/>
    <span class="label">Transport Name:</span> ${hdr?.transport || "No Transport Yet"}<br/>
    <span class="label">Order No:</span> ${hdr?.orderid || "-"}<br/>
    <span class="label">Order Date:</span> ${hdr?.orderdate ? new Date(hdr.orderdate).toLocaleDateString() : "-"}<br/>
    <span class="label">LR No:</span> ${hdr?.dispatchid || "Dispatched"}<br/>
    <span class="label">No of Cartons:</span> ${hdr?.noofcartoon || 0}
  </div>
</div>


      <table>
        <thead>
          <tr>
            <th>S No</th>
            <th>HSN</th>
            <th>Item Name</th>
            <th>Qty</th>
            <th>Unit</th>
            <th>Mrp</th>
            <th>Dis%</th>
            <th>S.D%</th>
            <th>E.D%</th>
            <th>Net Rate</th>
            <th>GST%</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          ${rows || `<tr><td colspan="12">No Items Found</td></tr>`}
        </tbody>
      </table>

      <div class="summary-grid">
     <div> 
  Taxable Amount<br/>
  ₹${Number(hdr?.amount || 0).toFixed(2)}

</div>

  ${totalIgst > 0
        ? `
      <div>
        IGST Amount<br/>
        ₹${totalIgst.toFixed(2)}
      </div>
    `
        : `
      <div>
        CGST Amount<br/>
        ₹${totalCgst.toFixed(2)}
      </div>
      <div>
        SGST Amount<br/>
        ₹${totalSgst.toFixed(2)}
      </div>
    `
      }


        <div>Coupon Amount<br/>${Number(hdr?.couponamount || 0).toFixed(2)}</div>
        <div>Wallet Amount<br/>${Number(hdr?.wallet || 0).toFixed(2)}</div>
        <div>Delivery Charges<br/>${Number(hdr?.delivarycharges || 0).toFixed(2)}</div>
        <div>Round Off<br/>0</div>
        <div>Net Amount<br/><b>${hdr?.netamount.toFixed(2) || 0}</b></div>
      </div>

      <div class="bank">
        <b>Bank Details:</b> ICICI BANK LIMITED, Hitech city, A/C NO: 437051000014, IFSC: ICIC0004370
      </div>

      <div class="terms">
        <b>Terms & Conditions:</b>
        <ol>
          <li>We are not responsible for Breakage/Damage/Shortage/Leakage in Transit.</li>
          <li>Responsibility ceases when goods delivered to carrier.</li>
          <li>Goods once sold will not be taken back.</li>
          <li>Interest 24% p.a. if invoice not paid before due date.</li>
          <li>Payment through banking only (RTGS/NEFT).</li>
        </ol>
      </div>

      <div class="signature">AUTHORIZED SIGNATURE</div>
    </div>

    <script>window.onload = function(){ window.print(); };</script>
  </body>
  </html>
  `;
  };

  useEffect(() => {
    if (orderid) handleGetOrders();
    getOrderInvoice();
  }, [orderid]);

  if (loading) return <LoadingSpinner text="Loading order details..." />;

  if (!order) return <p style={styles.centerText}>No order found</p>;

  return (
    <div style={{ backgroundColor: "white" }}>
      <div style={styles.container}>
        {/* BACK BUTTON */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            onClick={() => {
              console.log("navigating to /orders");
              navigate("/orders");
            }}
            style={styles.backBtn}
          >
            ← Back to Orders
          </div>
          <button onClick={() => handlePrintLabel()} style={styles.backBtn}>
            Download Invoice
          </button>
        </div>

        {/* ITEMS */}
        <h3 style={styles.heading}>Items in this order</h3>

        {order.details?.map((item) => {
          const product = item.products?.[0];
          if (!product) return null;

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <div
                key={item.id}
                style={{
                  ...styles.card,
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: isMobile ? "flex-start" : "center",
                }}
              >
                {/* IMAGE */}
                <div
                  onClick={() =>
                    navigate(`/productdetail?productid=${product.productid}`)
                  }
                  style={{
                    ...styles.imageWrap,
                    width: isMobile ? "100%" : "120px",
                    marginRight: isMobile ? 0 : "25px",
                    marginBottom: isMobile ? "10px" : 0,
                    textAlign: isMobile ? "center" : "left",
                  }}
                >
                  <img
                    src={product.image1?.trim() || noimage}
                    alt={product.modelno}
                    onError={(e) => (e.target.src = noimage)}
                    style={{
                      ...styles.image,
                      width: isMobile ? "80%" : "100%",
                    }}
                  />
                </div>

                {/* CENTER DETAILS */}
                <div style={styles.centerInfo}>
                  <p style={styles.text}>
                    <strong>Order ID:</strong>{" "}
                    <span style={styles.highlight}>{order.orderid}</span>
                  </p>

                  <p style={styles.text}>
                    <strong>Model No:</strong>{" "}
                    <span style={styles.highlight}>{product.modelno}</span>
                  </p>

                  <p style={styles.text}>
                    <strong>Brand:</strong>{" "}
                    <span style={styles.highlight}>{product.brand}</span>
                  </p>
                </div>

                {/* PRICE DETAILS */}
                <div
                  style={{
                    ...styles.priceInfo,
                    textAlign: isMobile ? "left" : "right",
                    minWidth: isMobile ? "100%" : "200px",
                    marginRight: isMobile ? 0 : "30px",
                    marginTop: isMobile ? "10px" : 0,
                  }}
                >
                  <p style={styles.text}>
                    <strong>Brand:</strong> {product.brand}
                  </p>

                  <p style={styles.text}>
                    <strong>Order Qty:</strong> {item.orderqty}
                  </p>

                  {/* <p style={styles.text}>
                    <strong>Price:</strong>{" "}
                    <span style={styles.highlight}>
                      ₹{Number(item.totalamount).toFixed(2)}
                    </span>
                    <br />
                    <span style={styles.subText}>(including GST)</span>
                  </p> */}
                  <p style={styles.text}>
                    <strong>Net Amount:</strong>{" "}
                    <span style={styles.highlight}>
                      ₹{Number(item?.totalamount || 0).toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>

              {/* review and comments */}
              {Number(order.delivered) === 1 && (
                <>
                  {!submittedReviews[product.productid] ? (
                    <div>
                      <Card
                        style={{
                          width: "100%",
                          marginBottom: 20,
                          borderRadius: 14,
                          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                        }}
                      >
                        <Row gutter={30} align="middle">
                          {/* Rating */}
                          <Col span={10}>
                            <p style={{ fontWeight: 500, marginBottom: 10 }}>
                              How would you rate it?
                            </p>
                            <Rate
                              value={reviews[product.productid]?.rating || 0}
                              onChange={(value) =>
                                setReviews((prev) => ({
                                  ...prev,
                                  [product.productid]: {
                                    ...prev[product.productid],
                                    rating: value,
                                  },
                                }))
                              }
                            />
                          </Col>

                          {/* Review */}
                          <Col span={14}>
                            <p style={{ fontWeight: 500, marginBottom: 10 }}>
                              Write your review
                            </p>
                            <TextArea
                              maxLength={200}
                              value={reviews[product.productid]?.review || ""}
                              onChange={(e) =>
                                setReviews((prev) => ({
                                  ...prev,
                                  [product.productid]: {
                                    ...prev[product.productid],
                                    review: e.target.value,
                                  },
                                }))
                              }
                            />
                          </Col>
                        </Row>

                        <div
                          style={{
                            marginTop: 20,
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 12,
                          }}
                        >
                          <Button size="large">Clear</Button>

                          <Button
                            type="primary"
                            size="large"
                            disabled={
                              !reviews[product.productid]?.rating ||
                              !reviews[product.productid]?.review?.trim()
                            }
                            style={{
                              background:
                                !reviews[product.productid]?.rating ||
                                  !reviews[product.productid]?.review?.trim()
                                  ? "#d9d9d9"
                                  : "#0A5587",
                              borderColor:
                                !reviews[product.productid]?.rating ||
                                  !reviews[product.productid]?.review?.trim()
                                  ? "#d9d9d9"
                                  : "#0A5587",
                              color:
                                !reviews[product.productid]?.rating ||
                                  !reviews[product.productid]?.review?.trim()
                                  ? "#999"
                                  : "#fff",
                            }}
                            onClick={async () => {
                              const success = await handleSubmit(
                                reviews[product.productid]?.review,
                                product.productid,
                                reviews[product.productid]?.rating,
                              );

                              if (success) {
                                setSubmittedReviews((prev) => ({
                                  ...prev,
                                  [product.productid]: true,
                                }));

                                localStorage.setItem(
                                  `review_${product.productid}`,
                                  "submitted",
                                );
                              }
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Card>
                    </div>
                  ) : (
                    <div
                      style={{
                        marginTop: -20,
                        marginBottom: 15,
                        padding: 15,
                        borderRadius: 10,
                        background: "#f6ffed",
                        border: "1px solid #b7eb8f",
                        color: "#005487",
                        fontWeight: 500,
                      }}
                    >
                      ✅ Thank you for your review!
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderDetails;

const styles = {
  container: {
    maxWidth: "900px",
    margin: "30px auto",
    padding: "0 15px",
    background: "white",
  },
  centerText: {
    textAlign: "center",
    marginTop: "50px",
  },
  backBtn: {
    marginBottom: "20px",
    background: "none",
    border: "none",
    color: "#005487",
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "700",
  },
  heading: {
    marginBottom: "15px",
    color: "black",
  },
  card: {
    display: "flex",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "12px",
    marginBottom: "20px",
    width: "100%",
  },
  imageWrap: {
    display: "flex",
    justifyContent: "center",
  },
  image: {
    height: "100px",
    objectFit: "contain",
  },
  centerInfo: {
    flex: 1,
  },
  priceInfo: {},
  text: {
    margin: "0 0 6px 0",
  },
  highlight: {
    color: "#005487",
    fontWeight: "600",
  },
  subText: {
    fontSize: "12px",
    color: "#666",
  },
};
